<template>
  <LoadingScreen />
</template>
<script>
import { mapState, mapActions } from 'vuex'
import LoadingScreen from '@/components-v2/common/loading/LoadingScreen.vue'
import googleSlideService from '@/services/google-slide'
import GoogleSlideApi from '@/api/googleSlide'

export default {
  components: {
    LoadingScreen,
  },
  data() {
    return {
      isLoading: null,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  async created() {
    await this.getPresentationGoogleSlide()
  },
  methods: {
    ...mapActions([
      'getCurrentUserAction',
    ]),
    async getPresentationGoogleSlide() {
      const infor = await googleSlideService.getPresentationGoogleSlide()
      await this.getAhaSlidesPresentation(infor.id)
      googleSlideService.listenGoogleSlideChangeActive()
    },
    async getAhaSlidesPresentation(googlePresentationId) {
      if (this.isLoading) return
      this.isLoading = true
      await this.getCurrentUserAction()
      const resp = await GoogleSlideApi.createGoogleSlidePresentation({
        googlePresentationId,
      })
      const params = {
        id: resp.id,
      }
      const query = {}
      this.isLoading = false
      setTimeout(() => {
        this.$router.push({ name: 'PresentationDetailGoogleSlide', params, query })
      }, 1000)
    },
  },
}
</script>
<style scoped lang="scss"></style>
